<template>
    <div class="news-page my-container page">
        <h1 class="header">{{ t('newsAndPromos') }}</h1>
        <BaseChipSelect :options v-model="currentType" align="left" :disabled="isLoading"></BaseChipSelect>
        <div class="news-list">
            <ApplicationNewsCard v-for="(entry, i) in newsList" :key="entry.id" :class="[4, 5].includes(i) && 'span2'"
                :news-data="entry" />
        </div>
    </div>
</template>

<script setup>
const { t, locale } = useI18n()
const { start, finish, isLoading } = useLoadingIndicator()
const rc = useRuntimeConfig();
const tags = ref();
const newsList = ref();
const currentType = ref(undefined)

async function getTags() {
    tags.value = (await $fetch(rc.public.api + '/api/tag')).data.list
}
async function getNews() {
    newsList.value = (await $fetch(rc.public.api + '/api/post', {
        query: {
            'filters[tag_id]': currentType.value
        }
    })).data.list
}
const options = computed(() => [
    {
        label: t('allNews'),
        value: undefined
    },
    ...tags.value.map(el => ({
        label: el.name[locale.value],
        value: el.id
    }))
])
await Promise.all([getTags(), getNews()])
watch(() => currentType.value, async () => {
    start();
    newsList.value = [];
    await getNews();
    finish()
})
</script>